import kamala from '../../kamala'
import Alert from './Alert'

Alert.install = function (Vue) {
  kamala(Vue)
  Vue.component(Alert.name, Alert)
}

export default Alert
